import { render, staticRenderFns } from "./MspGaraDetail.vue?vue&type=template&id=6e3333a2"
import script from "./MspGaraDetail.vue?vue&type=script&lang=js"
export * from "./MspGaraDetail.vue?vue&type=script&lang=js"
import style0 from "./MspGaraDetail.vue?vue&type=style&index=0&id=6e3333a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports